<template>
  <div class="search__empty">
    <p class="txt">
      <span class="color">‘{{ $route.query.keyword }}’</span>
      에 대한 결과를 찾을수 없습니다.<br />
      이런 서비스는 어떠신가요?
    </p>
    <RecoKeywords @bind="bindWord" @check-apply="checkApply" />
  </div>
</template>
<script>
import RecoKeywords from './RecoKeywords.vue';

export default {
  name: 'component-search-empty-data',
  description: '검색 페이지 > 검색 결과 없을때',
  components: { RecoKeywords },
  methods: {
    bindWord(item) {
      this.$emit('bind-word', item);
    },
    checkApply(type) {
      this.$emit('check-apply', type);
    },
  },
};
</script>
<style scoped></style>
